import { render, staticRenderFns } from "./FTemplate.vue?vue&type=template&id=109a3f72&scoped=true"
import script from "./FTemplate.vue?vue&type=script&lang=js"
export * from "./FTemplate.vue?vue&type=script&lang=js"
import style0 from "./FTemplate.vue?vue&type=style&index=0&id=109a3f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a3f72",
  null
  
)

export default component.exports